export default {
  namespaced      : true,
  state           : {
    detailModal : {
      isOpen                    :   false,
      characterId               :   null,
      immmediateryOpenAddModal  :   false
    }
  },

  mutations   : {
    setDetailModalIsOpen(state, value){
      state.detailModal.isOpen = value;
    },

    setDetailModalCharacterId(state, value){
      state.detailModal.characterId = value;
    },

    setImmmediateryOpenAddModal(state, value){
      state.detailModal.immmediateryOpenAddModal = value;
    },

    resetStore(state){
      state.detailModal.isOpen                    = false;
      state.detailModal.characterId               = null;
      state.detailModal.immmediateryOpenAddModal  = false;
    }
  },

  actions : {
    updateDetailModalIsOpen(context, payload){
      context.commit('setDetailModalIsOpen',      payload.value);
      context.commit('setDetailModalCharacterId', payload.characterId);

      if(typeof payload.immmediateryOpenAddModal !== 'undefined'){
        context.commit('setImmmediateryOpenAddModal', payload.immmediateryOpenAddModal);
      }else{
        context.commit('setImmmediateryOpenAddModal', false);
      }
    },

    resetStore(context){
      context.commit('resetStore');
    }
  }
}